import { MoonIcon, SunIcon } from '@playerbase/ui';

import { useTheme } from '../../theme/use-theme.js';

// Light/dark switch lifted out of the old sidebar logo strip. The
// topbar holds it now so the sidebar can collapse to icons cleanly.

export function ThemeToggle(): JSX.Element {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title="Toggle light/dark"
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-border-strong text-text-muted transition-colors hover:bg-surface-2 hover:text-text"
    >
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
